import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  container: {
    ...dFlex('initial', 'flex-start'),
    flexDirection: 'column',
    gap: 16,
  },
}));

export default useStyles;
